import type { TenantConfig } from "features/white-labeling/model/types";

import { customApiCall } from "utils/axios";

import tenantUrls from "./urls";

export const getTenantDomain = (): string => {
  if (typeof window === "undefined") return "";
  return window.location.hostname;
};

export const fetchTenantConfig = async (): Promise<TenantConfig> => {
  return await customApiCall.get({
    headers: {
      "X-Tenant-Domain": getTenantDomain(),
    },
    url: tenantUrls.config,
    useToken: false,
  });
};
